import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { translate, useTranslation } from 'react-i18next';
import './InfoTextExpandable.scss';


const InfoTextExpandable = ({ t, text, className }) => {
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef(null);
  const sanitizeText = () => ({
    __html: DOMPurify.sanitize(text, { ADD_ATTR: ['target'] })
  });
  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsOverflowing(el.scrollWidth > el.clientWidth);
    }
  }, [text]);
  return (
    <div className={`info-text-container ${className}`}>
      <div
        className="info-text"
        ref={textRef}
        style={{
          whiteSpace: expanded ? 'normal' : 'nowrap'
        }}
        dangerouslySetInnerHTML={sanitizeText()}
      />
      {isOverflowing && (
        <span onClick={() => setExpanded(!expanded)} className="show-button">
            {expanded ? t('common.showLess') : t('common.moreInfo')}
        </span>
      )}
    </div>
  );
};

InfoTextExpandable.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  t: PropTypes.func.isRequired
};

InfoTextExpandable.defaultProps = {
  text: '',
  className: 'info-text'
};

export default translate('common')(InfoTextExpandable);




// WEBPACK FOOTER //
// ./src/components/InfoTextExpandable/index.jsx